<div class="grid-container padding-y-4">
  <form [formGroup]="agencyTspSearchGroup" (ngSubmit)="search()">
    <fieldset class="usa-fieldset">
      <legend class="usa-legend usa-legend--large">User Administration</legend>
      <div class="grid-row grid-gap">
        <div class="grid-col-4">
          <label for="search_type" class="usa-label">Type<abbr title="required"
          class="usa-hint usa-hint--required">*</abbr></label>
          <select formControlName='searchCriteria' id="search_type" class="usa-select" (change)="onTypeChange()">
            <option hidden value='' selected disabled>Choose...</option>
            @for (searchForEntry of searchList; track searchForEntry) {
              <option [value]="searchForEntry">{{searchForEntry}}</option>
            }
          </select>
        </div>
      </div>
      <!-- show when Freight Carrier/Household Goods are selected -->
      @if (frtHhgCarrier) {
        <div class="grid-row grid-gap">
          <div class="grid-col-4">
            <label for="filterby_carrier" class="usa-label">Filter By<abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>
            <select id="filterby_carrier" class="usa-select" formControlName='carrierSearchCriteria'>
              <option hidden value='' selected disabled>Choose...</option>
              @for (carrierEntry of carrier; track carrierEntry) {
                <option [value]="carrierEntry">{{carrierEntry}}</option>
              }
            </select>
          </div>
          <div class="grid-col-4">
            <label for="search-keyword" class="usa-label">Keyword<abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" placeholder="Enter Keyword" [attr.disabled]="keywordDisabled?'':null" id="search-keyword"
              class="usa-input" formControlName='carrierKeyword' [typeahead]="typeaheadlist"
              [typeaheadMinLength]="minLengthToSearch" [typeaheadOptionsLimit]="10"
              [maxlength]="maxCharLength">
          </div>
        </div>
      }

      <!-- show when FRT/HHG Customer is selected -->
      @if (frtHhgAgencyCustomers) {
        <div class="grid-row grid-gap">
          <div class="grid-col-4">
            <label for="search-agency-name" class="usa-label">Agency Name<abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>
            <ng-template #agencySearchTemplate let-model="item" let-index="index">
              {{model.agencyBureauName}} - {{model.agencyCode}}
            </ng-template>
            <input id="search-agency-name" class="usa-input" formControlName='agencyName' placeholder="Search Agency"
              [typeaheadOptionsInScrollableView]="10" [typeaheadOptionsLimit]="300" [typeaheadMinLength]="0"
              (typeaheadOnSelect)="typeaheadAgencyOnSelect($event)"
              typeaheadOptionField="agencyBureauName" [typeahead]="agencyCustomerList"
              [typeaheadItemTemplate]="agencySearchTemplate" [typeaheadScrollable]="true">
          </div>
          <div class="grid-col-4">
            <label for="search-bureau-name" class="usa-label">Bureau Name<abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>
            <select id="search-bureau-name" class="usa-select" formControlName='bureauName'
              [compareWith]="compareBureauNameFn">
              <option hidden value='' selected disabled>Choose...</option>
              @for (bureau of agencyBureauList; track bureau) {
                <option [value]="bureau.bureauCode">
                  {{bureau.agencyBureauName}} - {{bureau.bureauCode}}
                </option>
              }
            </select>
          </div>
        </div>
      }

      <!--- show when User is selected -->
      @if (userCustomer) {
        <div class="grid-row grid-gap">
          <div class="grid-col-4">
            <label for="user_email" class="usa-label">Email<abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" id="user_email" formControlName="email" class="usa-input" [maxlength]="254">
            @if (this.agencyTspSearchGroup.get('email').hasError('email')) {
              <div class="text-danger">
                <span class="fa fa-warning"></span> Invalid Email
              </div>
            }
          </div>
        </div>
      }

      <div class="grid-row">
        <button type="button" class="usa-button margin-top-3" type="submit" [disabled]="!agencyTspSearchGroup.valid">
          Search
        </button>
        @if (agencyTspSearchGroup.get('searchCriteria').value === 'Freight TSP'
          || agencyTspSearchGroup.get('searchCriteria').value === 'HouseHold Goods TSP') {
          <a routerLink="/carrierprofile" [queryParams]="">
            <button type="button" class="usa-button usa-button--base margin-top-3">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#add"></use>
              </svg>
              TSP
            </button>
          </a>
        } @else {
          @if (this.showCreateAgency) {
            <a routerLink="/agencyprofile" [queryParams]="{agyMasterId: agencyMasterId}">
              <button class="usa-button usa-button--base margin-top-3">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#add"></use>
                </svg>
                Agency
              </button>
            </a>
          }
        }

      </div>
    </fieldset>
  </form>

  @if (results) {
    <div class="margin-top-5">
      <!-- <span>Note: Invalid Carrier data.</span> -->
      @if (showNoCarriers) {
        <div>Your search did not return any results</div>
      }
      <!-- search results for Freight Carrier/Household Goods -->
      @if (showFrtHhgCarrierTable) {
        <table class="usa-table usa-table--borderless usa-table--striped">
          <thead>
            <tr>
              <th>SCAC</th>
              <th colspan="2">TSP Name</th>
              @if ( this.businessType === 'HHG') {
                <th colspan="2">Domestic HHG</th>
              }
              @if ( this.businessType === 'HHG') {
                <th colspan="2">International HHG</th>
              }
              @if ( this.businessType === 'HHG') {
                <th colspan="2">Extended Storage</th>
              }
              @if ( this.businessType === 'FRT') {
                <th colspan="2">Domestic FRT</th>
              }
              <th colspan="2">TSP Status</th>
            </tr>
          </thead>
          <tbody>
            @for (carrier of resultsPage; track carrier) {
              <tr>
                <td>
                  @if ((carrier.organizationId && !carrier.deletedDate)) {
                    <span>
                      <a routerLink="" (click)="goToCarrierProfile(carrier)" routerLink="">{{carrier.scac}}</a>
                    </span>
                  } @else {
                    {{carrier.scac}}
                  }
                </td>
                <!--<td *ngIf="!(carrier.organizationId !== 0 && carrier.organizationId !== null && carrier.carrierStatus === 'Active')">{{carrier.scac}}</td>-->
                <td>{{carrier.scacName}}</td>
                <td></td>
                @if ( this.businessType === 'HHG') {
                  <td>{{carrier['Domestic HHG']}}</td>
                }
                @if ( this.businessType === 'HHG') {
                  <td></td>
                }
                @if ( this.businessType === 'HHG') {
                  <td>{{carrier['International HHG']}}</td>
                }
                @if ( this.businessType === 'HHG') {
                  <td></td>
                }
                @if ( this.businessType === 'HHG') {
                  <td>{{carrier['Extended Storage HHG']}}</td>
                }
                @if ( this.businessType === 'HHG') {
                  <td></td>
                }
                @if ( this.businessType === 'FRT') {
                  <td>{{carrier['Domestic FRT']}}</td>
                }
                @if ( this.businessType === 'FRT') {
                  <td></td>
                }
                <td>{{carrier.carrierStatus === 'Deleted' ? 'Revoked':carrier.carrierStatus}} @if (carrier.deletedDate) {
                  <span> on {{carrier.deletedDate | date:'MM/dd/YYYY'}}</span>
                }</td>
                @if (carrier.carrierStatus === 'Deleted') {
                  <td class="text-right" >
                    <button type="button" class="btn btn-warning btn-sm w-auto py-1 px-2" (click)="goToCarrierProfile(carrier)">
                      Reinstate TSP
                    </button>
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      }
      <!-- search results for User -->
      @if (showUserCustomer) {
        <table class="usa-table usa-table--borderless usa-table--striped">
          <thead>
            <tr>
              <th>Email</th>
              <th>Last Name</th>
              <th>Organization</th>
              <th>User Permission</th>
            </tr>
          </thead>
          <tbody>
            @for (orgUser of organizationUser; track orgUser) {
              <tr>
                <td>
                  @if (isValidPermissionForHyperLink(orgUser.organizationEntity, orgUser)) {
                    <span>
                      <a [routerLink]="[]" (click)="clickOnUser(orgUser)">
                      {{orgUser?.userEntity?.email}}</a>
                    </span>
                  } @else {
                    {{orgUser?.userEntity?.email}}
                  }
                </td>
                <td>{{orgUser?.userEntity?.lastName}}</td>
                <td>{{getOrganization(orgUser?.organizationEntity)}}</td>
                <td>{{getUserPermission(orgUser?.organizationEntity)}}</td>
              </tr>
            }
          </tbody>
        </table>
      }
      <!-- search results for Customer -->
      @if (showFrtHhgAgencyCustomers) {
        <div>
          <ag-grid-angular class="ag-theme-alpine" [rowData]="agencySearchList" [domLayout]="domLayout" [pagination]="true"
            [paginationPageSize]="itemsPerPage" [columnDefs]="agencyColumnDefs"
            (firstDataRendered)="onFirstDataRendered($event)">
          </ag-grid-angular>
        </div>
      }
    </div>
  }
</div>
